








































import { defineComponent, ref } from '@vue/composition-api';
import type { PropType } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  props: {
    participant: {
      type: Object as PropType<{
        email: string;
        firstName?: string;
        lastName?: string;
        title?: string;
        companyName?: string;
      }>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const updatedParticipant = ref(props.participant);

    const handleEnter = () => {
      emit('enter', updatedParticipant.value);
    };

    return { t, updatedParticipant, handleEnter };
  },
});
